module.exports = __webpack_public_path__ + "img/keyboard_F.051d8972.png";